export const transformSharesToStocks = (text: string) => (text === 'shares' ? 'stocks' : text);
